<template>
  <div>
    <div v-if="claimType">
      <div v-if="claimType.services.length">
        <ul class="nav nav-pills nav-justified form-navigation">
          <template v-for="(tab, index) in tabs">
            <li role="presentation" class="nav-item" :key="index">
              <a
                href="#"
                class="nav-link"
                :class="{ active: active == tab.name, disabled: tab.disabled }"
                @click.prevent="chooseTab(tab)"
                v-text="tab.label"
              ></a>
            </li>
          </template>
        </ul>

        <div class="card-body text-center" v-if="hasNoTariffId">
          <p class="m-0">
            You must select a tariff before you can deploy any services.
          </p>
        </div>

        <template v-if="!hasNoTariffId">
          <service-deployed
            service="hire"
            :incident="incident"
            :services="claimType.services"
            v-show="active === 'hire'"
            :readonly="readonly"
          >
            <slot name="hire"></slot>
          </service-deployed>

          <service-deployed
            service="repair"
            :incident="incident"
            :services="claimType.services"
            v-show="active === 'repair'"
            :readonly="readonly"
          >
            <slot name="repair"></slot>
          </service-deployed>

          <service-deployed
            service="salvage"
            :incident="incident"
            :services="claimType.services"
            v-show="active === 'salvage'"
            :readonly="readonly"
          >
            <slot name="salvage"></slot>
          </service-deployed>

          <service-deployed
            service="recovery"
            :incident="incident"
            :services="claimType.services"
            v-show="active === 'recovery'"
            :readonly="readonly"
          >
            <slot name="recovery"></slot>
          </service-deployed>

          <service-deployed
            service="diminution"
            :incident="incident"
            :services="claimType.services"
            v-show="active === 'diminution'"
            :readonly="readonly"
          >
            <slot name="diminution"></slot>
          </service-deployed>

          <service-deployed
            service="personal_injury"
            :incident="incident"
            :services="claimType.services"
            v-show="active === 'personal_injury'"
            :readonly="readonly"
          >
            <slot name="personalInjury"></slot>
          </service-deployed>
        </template>
      </div>

      <div
        class="text-center gutter-bottom half-gutter-top"
        v-if="!claimType.services.length"
      >
        No services can be deployed for "{{ claimType.label }}" claims!
      </div>
    </div>
  </div>
</template>
<script>
import ServiceDeployed from './ServiceTabs/ServiceDeployed';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    claimTypeId: {
      type: Number,
      required: true
    },
    claimTypes: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'service-deployed': ServiceDeployed
  },

  data() {
    return {
      active: undefined,
      tabs: [],
      claimType: null,
      faultServices: ['repair', 'salvage', 'recovery']
    };
  },

  computed: {
    isFaultClaim() {
      return this.$store.getters['Incident/isFaultClaim'];
    },
    incidentObject() {
      return this.$store.getters['Incident/incident'];
    },
    hasNoTariffId() {
      return !this.incidentObject || !this.incidentObject.tariff_id;
    }
  },

  mounted() {
    this.setClaimType();
    this.setTabs();
  },

  methods: {
    chooseTab(tab) {
      if (tab.disabled) {
        return;
      }

      this.active = tab.name;

      // Log that the user viewed the selected service tab, we use this to track which sections users are viewing
      window.Ajax.post(`/incidents/${this.incident}/log`, {
        module: this.module,
        tab: `Services - ${tab.label}`
      });

      this.$emit('services', this.claimType.services);
      this.$emit('selected', tab.name);
    },

    setClaimType() {
      if (this.claimTypes && this.claimTypes.length) {
        this.claimType = this.claimTypes.find(
          type => type.id === this.claimTypeId
        );
      }
    },

    setTabs() {
      if (this.claimType) {
        this.tabs = this.getServices(this.claimType).map(service => ({
          name: service.name,
          label: service.label,
          // Disable all tabs except 'hire' when tariff_id is null
          disabled: this.hasNoTariffId && service.name !== 'hire'
        }));

        if (this.tabs.length) {
          // If tariff_id is null, select the hire tab, otherwise select the first tab
          const tabToSelect = this.hasNoTariffId
            ? this.tabs.find(tab => tab.name === 'hire')
            : this.tabs[0];
          if (tabToSelect) {
            this.chooseTab(tabToSelect);
          }
        }
      }
    },

    getServices(claimType) {
      if (claimType.name === 'accident') {
        return this.claimType.services.filter(service => {
          if (this.isFaultClaim) {
            return this.faultServices.includes(service.name);
          }

          return true;
        });
      }

      return claimType.services;
    }
  },

  watch: {
    claimTypes() {
      this.setClaimType();
      this.setTabs();
    },
    hasNoTariffId() {
      this.setTabs();
    }
  }
};
</script>
